// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1LIFS","container":"styles_container__3dymC","title":"styles_title__3LHO9","wrapper":"styles_wrapper__2nY5K","answer":"styles_answer__3j6xA"};